module.exports = window["MaterialUI"].DialogTitle;